import * as api from 'api/trackedAccounts'

export const UPDATE_TRACKED_ACCOUNT = 'UPDATE_TRACKED_ACCOUNT'

export const updateTrackedAccount = (userId, data) => ({
  type: UPDATE_TRACKED_ACCOUNT,
  payload: api.updateTrackedAccount(userId, data)
})
